import { render, staticRenderFns } from "./ReactionBar.vue?vue&type=template&id=3e7e2b72&scoped=true&"
import script from "./ReactionBar.vue?vue&type=script&lang=js&"
export * from "./ReactionBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e2b72",
  null
  
)

export default component.exports